import { render, staticRenderFns } from "./AdultAvatarSelf.vue?vue&type=template&id=27cb9b0c&scoped=true&lang=pug"
import script from "./AdultAvatarSelf.vue?vue&type=script&lang=js"
export * from "./AdultAvatarSelf.vue?vue&type=script&lang=js"
import style0 from "./AdultAvatarSelf.vue?vue&type=style&index=0&id=27cb9b0c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cb9b0c",
  null
  
)

export default component.exports